import type WebSocket from 'ws';
import { CLI_VERSION } from '../cli-version.js';
import { sendWsMessage } from './create-ws-bridge.js';
import type { BridgeIdentifyReportedPaths } from './bridge-connection-runtime-types.js';
import type { CliE2eeRuntime } from '../lib/e2ee/index.js';

/** Re-report identify fields (including local shortcut credentials) on the bridge WebSocket. */
export function sendBridgeIdentify(
  ws: WebSocket | null,
  params: {
    identifyReportedPaths: BridgeIdentifyReportedPaths;
    e2ee?: CliE2eeRuntime;
  },
): void {
  if (!ws) return;
  const { identifyReportedPaths, e2ee } = params;
  sendWsMessage(ws, {
    type: 'identify',
    role: 'cli',
    cliVersion: CLI_VERSION,
    bridgeRootPath: identifyReportedPaths.bridgeRootPath,
    worktreesRootPath: identifyReportedPaths.worktreesRootPath,
    localShortcutPort: identifyReportedPaths.localShortcutPort,
    localShortcutToken: identifyReportedPaths.localShortcutToken,
    ...(e2ee ? { e: e2ee.handshake } : {}),
  });
}

/** Heartbeat interval is 10s; refresh identify every minute so DO hibernation cannot drop shortcut state. */
export const BRIDGE_IDENTIFY_REFRESH_EVERY_TICKS = 6;
